import {THEME} from '@wandb/weave/common/css/color.styles';
import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const AdvancedPropertiesHeader = styled.div`
  color: light-dark(${globals.TEAL_DARK}, var(--teal-450));
  cursor: pointer;
  height: 36px;
  line-height: 36px;
  font-weight: 600;
  &:hover {
    color: light-dark(${globals.TEAL_LIGHT}, var(--teal-400));
  }
`;
AdvancedPropertiesHeader.displayName = 'S.AdvancedPropertiesHeader';

export const ConstrainedIconContainer = styled.div`
  height: 24px;
  display: flex;
  padding: 3px;
  justify-content: center;
  align-items: center;
  background-color: light-dark(
    ${globals.TEAL_TRANSPARENT},
    color-mix(in srgb, var(--teal-500) 10%, transparent)
  );
  color: light-dark(${globals.TEAL}, var(--teal-450));
  border-radius: 4px;
  margin-left: 8px;
  cursor: pointer;
  &:hover {
    background-color: light-dark(
      ${globals.TEAL_LIGHT_TRANSPARENT},
      color-mix(in srgb, var(--teal-500) 20%, transparent)
    );
  }
`;
ConstrainedIconContainer.displayName = 'S.ConstrainedIconContainer';

export const UnconstrainedIconContainer = styled.div`
  height: 24px;
  display: flex;
  padding: 3px;
  color: ${THEME.textTertiary};
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  margin-left: 8px;
  cursor: pointer;
  &:hover {
    background-color: light-dark(var(--moon-100), var(--moon-900));
  }
`;
UnconstrainedIconContainer.displayName = 'S.UnconstrainedIconContainer';

export const AddNewSeriesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  border-top: 1px solid light-dark(#dddddd, var(--moon-750));
  color: ${THEME.textTertiary};
  cursor: pointer;
  &:hover {
    color: light-dark(var(--moon-600), var(--moon-400));
  }
`;
AddNewSeriesContainer.displayName = 'S.AddNewSeriesContainer';

export const AddNewSeriesText = styled.div`
  margin-left: 12px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
`;
AddNewSeriesText.displayName = 'S.AddNewSeriesText';

export const AddNewSeriesButton = styled.div`
  margin-right: 12px;
`;
AddNewSeriesButton.displayName = 'S.AddNewSeriesButton';
